<div class="internal-panel">

  <!-- Meta row: internal badge + print + close -->
  <div class="panel-meta-row" *ngIf="permit">
    <div class="internal-badge">
      <mat-icon class="lock-icon">lock</mat-icon>
      <span>{{ 'permit.manage.detail.internal' | translate }}</span>
    </div>

    <div class="panel-actions">
      <button type="button" class="action-btn" (click)="print()" [matTooltip]="'common.print' | translate">
        <mat-icon>print</mat-icon>
      </button>
      <button type="button" class="action-btn" (click)="close()"
        [matTooltip]="'permit.manage.detail.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Bciti tabs -->
  <app-bciti-tabs>

    <!-- Gestion -->
    <app-bciti-tab [title]="'permit.manage.detail.tab_management' | translate">
      <div class="sections-list">

        <app-permit-section-block [title]="'permit.manage.subtasks.title' | translate">
          <app-permit-subtasks [permit]="permit" (permitUpdated)="permitUpdated.emit()">
          </app-permit-subtasks>
        </app-permit-section-block>

        <app-permit-section-block [title]="'permit.manage.links.title' | translate">
          <app-permit-links [permit]="permit" (permitUpdated)="permitUpdated.emit()">
          </app-permit-links>
        </app-permit-section-block>

        <app-permit-section-block [title]="'permit.manage.tags.title' | translate">
          <div class="tags-body">
            <mat-chip-list #chipList>
              <mat-chip *ngFor="let tag of permit?.tags || []" [removable]="true" (removed)="removeTag(tag)">
                {{ tag }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <div class="add-tag-pill">
                <mat-icon class="add-tag-icon">add</mat-icon>
                <input [placeholder]="'permit.manage.tags.placeholder' | translate" [formControl]="tagCtrl"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                  (matChipInputTokenEnd)="addTag($event)" />
              </div>
            </mat-chip-list>
          </div>
        </app-permit-section-block>

        <app-permit-section-block [title]="'permit.manage.internal_files.title' | translate">
          <app-permit-internal-files [permit]="permit" (permitUpdated)="permitUpdated.emit()">
          </app-permit-internal-files>
        </app-permit-section-block>

      </div>
    </app-bciti-tab>

    <!-- Collaboration -->
    <app-bciti-tab [title]="'permit.manage.detail.tab_collaboration' | translate">
      <div class="sections-list">

        <app-permit-section-block [title]="'permit.manage.collaboration.notes_title' | translate">
          <app-permit-internal-note [permit]="permit" (permitUpdated)="permitUpdated.emit()">
          </app-permit-internal-note>
        </app-permit-section-block>

      </div>
    </app-bciti-tab>

    <!-- Historique -->
    <app-bciti-tab [title]="'permit.manage.detail.tab_history' | translate">
      <div class="sections-list">

        <app-permit-section-block [title]="'permit.manage.history.title' | translate">
          <app-permit-history [permit]="permit"></app-permit-history>
        </app-permit-section-block>

      </div>
    </app-bciti-tab>

  </app-bciti-tabs>

</div>